import { render, staticRenderFns } from "./FormPerson.vue?vue&type=template&id=7523b92e&"
import script from "./FormPerson.vue?vue&type=script&lang=js&"
export * from "./FormPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports